import {
  ApplicationConfig,
  provideZoneChangeDetection,
  isDevMode,
  LOCALE_ID,
  ErrorHandler,
  APP_INITIALIZER,
  importProvidersFrom,
} from '@angular/core';
import { provideRouter, Router } from '@angular/router';
import { routes } from './app.routes';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { provideEffects } from '@ngrx/effects';
import { localStorageSyncReducer,  reducers } from './@core/store/app/app.reducer';
import { AuthenticationService } from './modules/authentication/authentication.service';
import * as Sentry from '@sentry/angular';
import { HttpInterceptorService } from './@core/services/http-interceptor.service';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';
import { OAuthModule } from 'angular-oauth2-oidc';
import { AuthService } from './modules/authentication/auth.service';

import { ProviderEffects } from '../app/@core/store/provider/provider.effects';
import { PolicyHolderEffects } from './@core/store/policyholder/policyholder.effects';
import { NotificationEffects } from './@core/store/notification/notification.effects';
import { DropdownEffects } from './@core/store/dropdown/dropdown.effects';
import { EnrolleeEffects } from './@core/store/enrollee/enrollee.effects';
export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: HttpInterceptorService, multi: true },
    importProvidersFrom(OAuthModule.forRoot()),

    // ✔ CLEAN NEW STORE
    provideStore(
      reducers,
      { metaReducers: [localStorageSyncReducer] }
    ),

    // ✔ EFFECTS
    provideEffects([
      ProviderEffects,
      PolicyHolderEffects,
      NotificationEffects,
      DropdownEffects,
      EnrolleeEffects
    ]),

    provideStoreDevtools({ maxAge: 25, logOnly: !isDevMode() }),
    provideAnimations(),
    provideToastr({
      timeOut: 4000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
      progressBar: true,
    }),

    { provide: LOCALE_ID, useValue: 'en-NG' },
    AuthenticationService,

    {
      provide: APP_INITIALIZER,
      useFactory: (authService: AuthService) => () => authService.init(),
      deps: [AuthService],
      multi: true,
    },

    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
  ],
};
